export default __webpack_public_path__ + "assets/sounds/9255c740dcae3e3748aada97e30cab09.mp3";